export const CUSTOM_CHAT_LAUNCH_EVENT = 'customChatLaunch';
